import "./SubscriptionFreePage.scss";
import { Button } from "../misc/Button";
import { useRecoilValue } from "recoil";
import { memberState } from "../../../state/atoms";

export function SubscriptionFreePage() {
  const member = useRecoilValue(memberState);
  function onSwitchPlansClick() {
    window.MHM.ProModal.upgrade({ memberId: member.id, onSuccess: () => window.location.reload() });
  }

  return (
    <div className={"content free-subscription-page "}>
      <h4 className={"subscription-banner"}>
        You're currently using the Design Plan.
      </h4>

      <div className="flex">
        <div className={"side-info"}>
          <div>
            <h4>
              To get the full experience, go Pro <img className="pro-star-circle" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="Pro star" />
            </h4>
            <div className={"price-container"}>
              <h2 id={"price"}>$33/mo </h2>
              <div>paid annually</div>
            </div>
          </div>

          <div className="modal-font-size">
            Multi-channel menu management and marketing.
          </div>

          <section>
            <ul className={"design-list"}>
              <li>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CheckmarkRed.svg" alt="check" />
                <span>25,000+ hospitality-ready design templates</span>
              </li>
              <li>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CheckmarkRed.svg" alt="check" />
                <span>Pull from your POS menu data</span>
              </li>
              <li>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CheckmarkRed.svg" alt="check" />
                <span>Unlimited hi-res downloads<br /><b><i>NEW - MP4 Video download!</i></b></span>
              </li>
              <li>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CheckmarkRed.svg" alt="check" />
                <span>Unlimited views for QR Codes, link pages and online menus</span>
              </li>
              <li>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CheckmarkRed.svg" alt="check" />
                <span>Advanced design: custom sizes, font uploads and more!</span>
              </li>
              <li>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CheckmarkRed.svg" alt="check" />
                <span>Extend with teams and locations</span>
              </li>
              <li>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CheckmarkRed.svg" alt="check" />
                <span>Extend with Display app</span>
              </li>
              <li>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CheckmarkRed.svg" alt="check" />
                <span>Priority customer support</span>
              </li>
            </ul>
          </section>

          <footer>
            <Button type={'Primary'} onClick={onSwitchPlansClick}>
              <span>Get Pro</span>
            </Button>
          </footer>
        </div>

        <div className="img desktop-only">
          <img
            loading="lazy"
            src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/SubQuadrantDesktop.webp"
            alt={"Loading..."}
          />
        </div>

        <div className="img mobile-only">
          <img
            loading="lazy"
            src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/SubQuadrantMobile.webp"
            alt={"Loading..."}
          />
        </div>
      </div>
    </div>
  );
}
